<!--StudentAnswer:学生答案页面 2024/01/25 13:53:29 XIJIGUO-->
<template>
  <div class="student-answer" v-loading="studentListLoading">
    <div class="ques-type">
      <answer-radio :list="list" :studentType="studentType" :is-show-position-error="isShowPositionError" @click-item="clickItem"></answer-radio>

      <el-select v-if="showChooseSubject" @change="handleCurrentChange()" v-model="currOptional" class="options" size="mini" clearable placeholder="请选择">
        <el-option v-for="item in optionals" class="option" :key="'option-' + item.name" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="search-wrapper">
      <div>

        <!-- 展示条件  非需要批量展示并且当前为批量显示 -->
        <template v-if="!(isNeedBatch && isBatch)">
          <template v-if="loginPlatform === 'region'">
            <el-select v-model="answerSchoolId" style="width:200px" size="mini" placeholder="选择学校" @change="handleChangeSchool()">
              <el-option v-for="(item, index) in schoolList" :key="'school-' + index" :label="item.schoolName" :value="item.id"></el-option>
            </el-select>
          </template>

          <el-select v-model="classId" style="width:100px" size="mini" clearable placeholder="选择班级" @change="handleCurrentChange()">
            <el-option v-for="item in classList" :key="'class-' + item.id" :label="item.className" :value="item.id"></el-option>
          </el-select>

          <el-input size="mini" v-model="keyword" @change="handleCurrentChange()" clearable placeholder="搜索(考号/姓名)" style="width: 186px;" suffix-icon="el-icon-search">
          </el-input>
        </template>
        <!--定位异常批次-->
        <template v-if="['POSITION_ERROR'].indexOf(studentType.id) >= 0">
          <el-select v-model="batchId" style="width:100px" size="mini" placeholder="选择批次" @change="handleCurrentChange()">
            <el-option v-for="item in positionErrorList" :key="'class-' + item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </template>
      </div>

      <div>
        <template v-if="backDoor">
          <el-button class="btn-margin" type="danger" @click="cancelAllAbsenceMarks" size="mini">取消全部缺考标记</el-button>
          <el-button class="btn-margin" type="warning" @click="downloadAnomalyList" size="mini">导出异常名单</el-button>
          <el-button class="btn-margin" type="danger" @click="reNewStudent" size="mini">重建学生</el-button>
          <template v-if="isAewIdentify">
            <el-button type="danger" @click="anewIdentify" size="mini">登分框全部重识别</el-button>
            <el-checkbox v-model="rendering" size="mini">分数转红色</el-checkbox>
          </template>
        </template>

        <template v-if="isNeedBatch">
          <el-button type="text" class="el-icon-sort" @click="isBatch = !isBatch">{{ isBatch ? '单个' : '批量' }}处理</el-button>
        </template>
      </div>
    </div>

    <!-- 批量处理 -->
    <div v-show="isNeedBatch && isBatch">
      <batch-question ref="batchQuestion" :student-type="studentType" :exam-id="examId" :school-id="answerSchoolId" @click-item="clickItem"></batch-question>
    </div>
    <div v-show="!(isNeedBatch && isBatch)">
      <!-- 单个处理 -->
      <div class="student-answer-content">
        <answer-student-list ref="studentList" :studentList="studentList" @handleSelectionChange="handleSelectionChange" @handleRowChange="handleRowChange" :showErrorDesc="studentType.id === 'POSITION_ERROR'"></answer-student-list>
        <div class="student-img" v-loading="imgLoading">
          <div class="tab-bar">
            <div class="tab-left">
              <!-- 非在线考试才展示批改详情 -->
              <div v-if="!isOnline && isReadWritePermission(2)">
                <span style="margin-right:8px;">批改详情</span>
                <el-switch v-model="showCorrectionDetail" active-color="#13ce66" :disabled="currStudent.NotAnnotations.length === 0|| missExam">
                </el-switch>
              </div>
            </div>

            <div v-if="currStudent.isAnswer" class="tab-right">
              <i @click="handleRotate"><img style="margin-left: 6px;" src="~images/answer/rotate.svg" /></i>
              <i @click="handPreview" style="padding:8px 8px 8px 0; "><img style="margin-left: 6px;" src="~images/answer/browse.svg" /></i>
              <el-popover v-model="scaleDownVisible" popper-class="scale-item-popover" placement="bottom" trigger="hover">
                <ul class="scale-item-more">
                  <li v-for="(scale, index) in scaleCollection" :key="`scale-${index}`" @click="handleChangeScale(scale)" class="scale-item" :class="{ active: currScale.value === scale.value }">
                    {{ scale.title }}</li>
                </ul>
                <el-button slot="reference" class="btn-margin" type="text" size="small">
                  {{ currScale.title }}
                  <i v-if="scaleDownVisible" class="el-icon-arrow-up" />
                  <i v-else class="el-icon-arrow-down" />
                </el-button>
              </el-popover>
            </div>
          </div>
          <div class="student-img-warpper">
            <div v-show="currStudent.isAnswer">
              <div :style="imageStyle">
                <canvas ref="studentImg"></canvas>
              </div>
            </div>
            <div v-if="!currStudent.isAnswer" class="nodata">
              <p><img src="~images/unable-preview.png" /></p>
              <p v-if="isOnline" class="nodata-text">在线考试无需上传答题卡</p>
              <p v-else class="nodata-text">暂未上传答题卡</p>
            </div>
            <div v-if="currStudent.hasGrading && currStudent.studentPaperType === 'DOUBT_REPEAT'" class="marking-desc">
              {{ currStudent.gradingTeachers ? currStudent.gradingTeachers.join('、') : '' }}已批阅
            </div>
          </div>
        </div>
        <div class="student-info" v-loading="updateStudentLoading">
          <template v-if="studentList.length > 0">
            <div class="student-detail">
              <div>
                <span class="label">考号：</span>
                <student-auto-complete key="examNo" :input="studentInfo.examNo" :exam-info="examInfo" placeholder="请输入考号/学生名称" @confirmStudent="handleSearchStudentClick" :disabled="['UN_UPLOAD', 'POSITION_ERROR'].indexOf(currStudent.studentPaperType) >= 0">
                </student-auto-complete>
              </div>
              <div>
                <span class="label">姓名：</span>
                <student-auto-complete key="studentName" :input="studentInfo.studentName" :exam-info="examInfo" placeholder="请输入考号/学生名称" @confirmStudent="handleSearchStudentClick" :disabled="['UN_UPLOAD', 'POSITION_ERROR'].indexOf(currStudent.studentPaperType) >= 0">
                </student-auto-complete>
              </div>
              <div>
                <span class="label">参与统计：</span>
                <span class="exam-result">
                  <span v-if="currStudent.examResult && ['UPLOAD'].indexOf(currStudent.studentPaperType) > -1">
                    <el-switch :disabled="!isPermission" @change="handleCountSwitch()" v-model="currStudent.examResult.amentiaFlag" :active-value="1" :inactive-value="0"></el-switch>
                  </span>
                  <span v-else style="font-size:13px;line-height:22px" :title="amentiaReason"> {{ amentiaReason }}</span>
                </span>
              </div>
              <template v-if="isPermission">
                <div>
                  <template v-if="['UPLOAD', 'ABSENT', 'UN_UPLOAD'].indexOf(currStudent.studentPaperType) > -1">
                    <span class="label">缺考：</span>
                    <span @click="missExamVisible = true" style="cursor: pointer;margin-right: 16px;">
                      <el-checkbox v-model="missExam" style="pointer-events: none;"></el-checkbox>
                    </span>
                  </template>
                  <template v-if="['UPLOAD','DOUBT_REPEAT', 'DOUBT_STUDENT_ABSENT', 'NOT_IN_JOIN_LIST','NO_NAME_PAPER'].indexOf(currStudent.studentPaperType) > -1">
                    <span class="label">无名卷：</span>
                    <el-checkbox v-if="currStudent.studentPaperType==='UPLOAD'" disabled></el-checkbox>
                    <span v-else @click="UnnamedVolumeClick" style="cursor: pointer;">
                      <el-checkbox v-model="isNameless" style="pointer-events: none;"></el-checkbox>
                    </span>
                  </template>
                </div>
              </template>
              <div>
                <span class="label">得分：</span>
                <span class="text"> {{ showReport && !missExam && isReadWritePermission(2) ? (currStudent.examResult ? currStudent.examResult.totScore || 0 : 0) : '--' }} </span>
              </div>
              <!-- 打回重传功能只有在线考试有 -->
              <div v-if="isOnline && currStudent && currStudent.resultId">
                <span class="label">操作：</span>
                <span class="text" @click="reUpload" style="color: #2877ff;cursor: pointer;">
                  打回重传
                </span>
              </div>
            </div>
            <div class="question-list" v-if="!missExam">
              <template v-if="currStudent.examResult && objectiveList.length > 0 && !notStudentInfo">
                <div class="title">客观题({{ isReadWritePermission(2) ? (currStudent.examResult.objScore || 0) : '--' }}分)
                </div>
                <ul class="objective-question">
                  <li v-for="(objective, index) in objectiveList" :key="`objective-${index}`">
                    <div class="question-num" :title="objective | standardQuestionNumber">
                      {{ objective | standardQuestionNumber }}
                    </div>

                    <template v-if="isReadWritePermission(3)">
                      <el-popover :ref="`objective-${objective.num}`" placement="bottom" trigger="click" popper-class="objective-popover" @show="initObjectiveAnswer(objective)" @hide="changeObjectiveAnswer(objective)">
                        <div>
                          <ul class="search-student-list">
                            <li v-for="(option, index) in objective.optionPositions" :style="getSelectOptionStyle(objective, option.value)" :key="`option-${index}`" @click="changeOption(objective, option.value)">{{ option.value }}
                            </li>
                          </ul>
                        </div>
                        <div class="question-answer" :style="getObjectiveAnswerStyle(objective)" :title="objective.answer" slot="reference"> {{ objective.answer }}</div>
                      </el-popover>
                    </template>
                    <template v-else>
                      <div class="question-answer" :style="getObjectiveAnswerStyle(objective)" :title="objective.answer" slot="reference"> {{ objective.answer }}</div>
                    </template>
                  </li>
                </ul>
              </template>

              <template v-if="currStudent.examResult && subjectiveList.length > 0">
                <div class="title">主观题({{ showReport && isReadWritePermission(2) ? (currStudent.examResult.subScore || 0) : '--' }}分)</div>
                <ul class="subjective-question">
                  <li v-for="(subjective, index) in subjectiveList" :key="`subjective-${index}`">
                    <div class="question-num" :title="subjective | standardQuestionNumber">
                      {{ subjective | standardQuestionNumber }}</div>
                    <div v-if="showReport && isReadWritePermission(2)" class="question-score" :style="{ 'color': subjective.score == 0 ? '#FF4C3B' : '' }" :title="`${subjective.score || 0}分`" @click="handleChangeSubjectiveScoreVisible(subjective)">
                      {{ subjective.score || 0 }}分</div>
                  </li>
                </ul>
              </template>
            </div>
          </template>
          <div v-else class="nodata">
            暂无数据
          </div>
        </div>
      </div>

      <div class="footer">
        <template v-if="pagination.total > 0">
          <div>
            <span class="desc">已选{{ stuSelectCount }}条</span>
            <span @click="delAnswerSheetVisible = stuSelectCount > 0" class="span-btn" :class="{ disabled: stuSelectCount === 0 }">删除已选</span>
            <template v-if="exceptions.indexOf(studentType.id) >= 0">
              <span @click="confirmDoubt" class="span-btn" :class="{ disabled: stuSelectCount === 0 }">确认正常</span>
              <el-tooltip popper-class="help-tip-popover" effect="dark" placement="top">
                <span class="help-icon"></span>
                <div slot="content" class="help-tip-content">
                  <p>若您认为答题卡无偏移，可点击“确认正常”，让答题卡进入后续的流程。</p>
                  <p>注：若答题卡存在严重异常，程序无法识别，即使您手动点击“确认正常”，仍然会留在“定位异常”里，那么您需要创建多模板重识别来解决异常卡。</p>
                </div>
              </el-tooltip>
            </template>
            <template v-if="['ALL', 'POSITION_ERROR'].indexOf(studentType.id) >= 0">
              <span @click="reOcr" class="span-btn">重识别</span>
              <!-- 有痕旧版考试隐藏定位异常、多模板 -->
              <template v-if="isHenPermission">
                <span v-if="studentType.id === 'ALL' && backDoor" @click="setPositionError" class="span-btn">标记为定位异常</span>
                <!-- 区域考试、在线考试不能创建多模板 -->
                <template v-if="isCreateTemplatePermission">
                  <span @click="createMultiTemplate" class="span-btn">创建多模板</span>
                  <el-tooltip popper-class="help-tip-popover" effect="dark" :content="templateTip" placement="top">
                    <span class="help-icon"></span>
                  </el-tooltip>
                </template>
              </template>

              <template v-if="studentType.id === 'POSITION_ERROR'">
                <span @click="restorePaperAction" class="span-btn">还原到原卷</span>
                <el-tooltip popper-class="help-tip-popover" effect="dark" placement="top">
                  <span class="help-icon"></span>
                  <div slot="content" class="help-tip-content">
                    <p>若使用多模板重识别后，学生答题卡出现拼接异常，可通过还原到原卷功能，恢复到扫描仪第一次扫描、上传的状态。</p>
                  </div>
                </el-tooltip>
              </template>
            </template>
          </div>
          <yue-pagination key="single" :pageSizes="pageSizes" :page="pagination" @current-change="handleCurrentChange" @size-change="handleSizeChange"></yue-pagination>
        </template>
      </div>
    </div>

    <label v-if="isAewIdentify" class="identify-tip">如有半分框，请勿重识别!</label>

    <!--标记无名卷-->
    <yue-dialog :visible.sync="labelUnnamedVolumeVisible" title="无名卷设置" width="500px" center custom-class="label-unnamed-volume">
      <div class="content">
        设置无名卷后，该考试将取消学生信息！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="height: 34px;" @click="labelUnnamedVolume"> 确定 </el-button>
        <el-button style="height: 34px;" @click="labelUnnamedVolumeVisible = false"> 取消 </el-button>
      </span>
    </yue-dialog>

    <!--删除已选-->
    <yue-dialog :visible.sync="delAnswerSheetVisible" title="提示" width="500px" center custom-class="del-answer-sheet">
      <div class="content">
        <div class=left>
          <div class="title">
            <el-radio v-model="delType" label="1">删除所选试卷</el-radio>
          </div>
          <template v-if="delType === '1'">
            <div class="text">确定要删除选中的
              <span style="color:#FF4C3B">{{ stuSelectCount }}份</span>
              试卷？
            </div>
            <div class="text">删除后试卷信息会丢失！</div>
          </template>
        </div>
        <div v-if="exceptions.indexOf(studentType.id) === -1" class="right">
          <div class="title"> <el-radio v-model="delType" label="2" @change="() => { delStudentNumberType = '2' }">删除重复学号</el-radio> </div>
          <template v-if="delType == '2'">
            <div class="text"> <el-radio v-model="delStudentNumberType" label="1">保存最新数据</el-radio> </div>
            <div class="text"> <el-radio v-model="delStudentNumberType" label="2">保留最早数据</el-radio></div>
          </template>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="height: 34px;" @click="delAnswerSheet"> 确定删除</el-button>
        <el-button style="height: 34px;" @click="delAnswerSheetVisible = false"> 取消 </el-button>
      </span>
    </yue-dialog>

    <!--缺考弹窗-->
    <yue-dialog :visible.sync="missExamVisible" title="缺考设置" width="500" center custom-class="miss-exam">
      <div class="content">
        <div style="margin-top: 20px;margin-bottom: 32px;">
          设置缺考后，该考生本次考试将没有成绩！
        </div>
        <div>
          <el-radio v-model="examState" label="1"><span style="margin-left: 8px;">缺考</span></el-radio>
          <el-radio v-model="examState" label="2"><span style="margin-left: 8px;">正常考试</span></el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="height: 34px;" @click="handleChangeMissExam"> 确定修改</el-button>
        <el-button style="height: 34px;" @click="missExamVisible = false"> 取消 </el-button>
      </span>
    </yue-dialog>

    <!--修改主观题弹窗-->
    <yue-dialog :visible.sync="setSubjectiveScoreVisible" title="修改分数" width="500" center custom-class="set-subjective-score">
      <div class="content">
        <el-form style="margin:0 130px;" ref="setSubjectiveScore" label-width="100px" :model="currSubjective" :rules="rules" @submit.native.prevent>
          <el-form-item label="题目编号：">
            <span>{{ currSubjective | standardQuestionNumber }}</span>
          </el-form-item>
          <el-form-item label="题目满分：">
            <span>{{ currSubjective.maxScore }}</span>
          </el-form-item>
          <el-form-item label="阅卷详情：">
            <span>{{ currSubjective.batchTeacherName }}</span>
          </el-form-item>
          <el-form-item label="阅卷分数：">{{ currSubjective.score || 0 }}</el-form-item>
          <el-form-item label="修改分数：" prop="studentScore">
            <span style="display:flex;width:80px;">
              <el-input type="number" v-model.number="currSubjective.studentScore" style="margin-right:8px"></el-input>分
            </span>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <span style="color:red;font-size:14px;">请修改完全部成绩后，点击考试列表-更多-重新生成单科报告，生成最新报告</span>
        <span class="dialog-footer">
          <el-button type="primary" style="height: 34px;" @click="handleChangeSubjectiveScore"> 确定修改</el-button>
          <el-button style="height: 34px;" @click="setSubjectiveScoreVisible = false"> 取消 </el-button>
        </span>
      </template>
    </yue-dialog>

    <!--图片预览组件-->
    <el-image class="preview-img" ref="preview" :src="previewImage" :preview-src-list="[previewImage]"></el-image>

    <!--重识别进度条-->
    <yj-progress ref="progressRef" :progressDesc="progressDesc" :scheduleDialog="scheduleDialog" :taskId="taskId" @confirm="closeProgress"></yj-progress>

    <yue-dialog title="重识别" :visible.sync="ocrDialog.visible" width="758px">
      <div class="dialog-body">
        <div v-if="ocrDialog.templates" class="dialog-body-content">
          <template-group :form="ocrDialog" :list="ocrDialog.templates.filter(t => t.templateNum < 3)"></template-group>
          <template-group :form="ocrDialog" :list="ocrDialog.templates.filter(t => t.templateNum >= 3)"></template-group>
        </div>
        <p class="dialog-body-footer">
          <el-button type="primary" size="mini" @click="ocrTemplate">确认</el-button>
          <el-button style="margin-left: 32px" type="primary" size="mini" plain @click="ocrDialog.visible = false">取消</el-button>
        </p>
      </div>
    </yue-dialog>

    <!--还原到原卷-->
    <yue-dialog :visible.sync="restoreScanBatchPaperVisible" title="还原到原卷" width="500px" center custom-class="label-unnamed-volume">
      <div class="content" style="margin-bottom: 0px;">
        将还原答题卡到客户端上传后的最初结果，无法撤回，是否确认还原？
      </div>
      <span slot="footer" class="dialog-footer" style="margin-top: 20px;">
        <el-button type="primary" style="height: 34px;" @click="restoreScanBatchPaper"> 确定 </el-button>
        <el-button style="height: 34px;" @click="restoreScanBatchPaperVisible = false"> 取消 </el-button>
      </span>
    </yue-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ZjPagination from '@/pages/zujuan/components/ZjPagination.vue'
import StudentAutoComplete from '@/pages/components/StudentAutoComplete.vue'
import util from "@/utils/util"
import { getStudentPaper, labelUnnamedVolume, delStudentPaper, getDistinguish, setDistinguishMark, setDistinguishExamType, getGradingRecord, updateDistinguish, getShowChooseSubject, exportStudent, getListAllStand } from '@/api/exam/exam'
import { xDraw } from '@/utils/draw.js'
import { sDraw } from '@/utils/studentAnswerDraw.js'
import { networkData } from '@/v2/utils/data'
import { examApi } from '@/v2/utils/api'
import YjProgress from '@/components/YjProgress'
import { magicApi } from '@/utils/magic'
import auth from '@/v2/utils/auth'
import AnswerRadio from '@/v3/modules/card_use/views/student-answer/components/AnswerRadio.vue'
import AnswerStudentList from '@/v3/modules/card_use/views/student-answer/components/StudentTable.vue'
import TemplateGroup from '@/v3/modules/card_use/views/student-answer/components/TemplateGroup.vue'
import BatchQuestion from '@/v3/modules/card_use/views/student-answer/components/BatchQuestion.vue'

export default {
  name: 'StudentAnswerNew',
  components: {
    ZjPagination,
    StudentAutoComplete,
    AnswerRadio,
    AnswerStudentList,
    YjProgress,
    TemplateGroup,
    BatchQuestion
  },
  props: {
    examInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    resultId: {
      type: String,
      default: () => ''
    },
    isRegion: {
      type: Boolean,
      default: () => false,
    },
    loginPlatform: {
      type: String,
      default: () => '',
    },
    schoolId: {
      type: String,
      default: () => ''
    }
  },
  data () {
    let checkStudentScore = (rule, value, callback) => {
      if (util.isEmpty(value + '')) {
        return callback(new Error("请输入分值"));
      }
      // 使用正则表达式检查字符串是否匹配小数点后只有一位数字的数字模式
      var pattern = /^\d*\.?\d$/;

      if (!pattern.test((value + '').trim())) {
        callback(new Error("请输入数字值且小数点后最多一位"));
      } else {
        if (value < 0 || value > this.currSubjective.maxScore) {
          callback(new Error(`请输入0-${this.currSubjective.maxScore}之间的分值`));
        } else {
          callback();
        }
      }
    };
    return {
      studentTypeList: [
        {
          id: "ALL",
          type: 0,
          name: '全部',
          total: "0"
        },
        {
          id: "REFERRENCE_NUMBER",
          type: 0,
          name: '参考人数',
          total: "0"
        },
        {
          id: "UPLOAD",
          type: 1,
          name: "已上传",
          total: "0"
        },
        {
          id: "UN_UPLOAD",
          type: 2,
          name: "未上传",
          total: "0"
        },
        {
          id: "POSITION_ERROR",
          type: -2,
          name: "定位异常",
          total: "0"
        },
        {
          id: "FOLDING_ANGLE_ISSUE",
          type: -3,
          name: "折角",
          total: "0"
        },
        {
          id: "ABSENT",
          type: 4,
          name: "缺考",
          total: "0"
        },
        {
          id: "DOUBT_REPEAT",
          doubtType: 'CLASS_REP',
          type: 12,
          name: '重复',
          total: "0"
        },
        {
          id: "DOUBT_STUDENT_ABSENT",
          doubtType: 'CLASS_NO_EXIST',
          type: 13,
          name: "不存在",
          total: "0"
        },
        {
          id: "NOT_IN_JOIN_LIST",
          doubtType: 'NOT_IN_JOIN_LIST',
          type: 16,
          name: "不在参考名单",
          total: "0"
        },
      ],
      studentType: {},
      keyword: '',
      pagination: {
        total: 0,
        size: 50,
        current: 1
      },
      pageSizes: [50, 100, 200, 500, 1000],
      studentListLoading: false,
      studentList: [],
      studentSelection: [],
      optionals: [
        { id: 0, name: '选科' },
        { id: 1, name: '未选科' },
      ],
      currOptional: '',
      currStudent: {
        isAnswer: false,
        studentName: '',
        NotAnnotations: [],
      }, // 当前学生
      labelUnnamedVolumeVisible: false, // 标记无名卷是否可见
      delAnswerSheetVisible: false, // 删除试卷是否可见
      delType: "1", // 删除类型
      delStudentNumberType: "1", // 删除学号类型
      missExamVisible: false, //  缺考弹窗是否显示
      missExam: false, // 缺考状态
      isNameless: false, // 是否无名卷
      examState: '1', // 考试状态
      objectiveList: [], // 客观题
      subjectiveList: [], // 主观题
      showCorrectionDetail: false, // 是否显示批改详情
      scaleCollection: [
        { title: '20%', value: 0.2 },
        { title: '50%', value: 0.5 },
        { title: '100%', value: 1 },
        { title: '150%', value: 1.5 },
        { title: '200%', value: 2 },
        { title: '250%', value: 2.5 },
      ],
      currScale: null,
      scaleDownVisible: false, // 设置比例是否可见
      previewImg: { src: '', list: [] },
      previewImage: '',
      initialIndex: 0,
      imageStyle: {},
      rotateIndex: 0, // 旋转数
      canvas: null, // 画布
      timer: null, // 定时器
      backgroundImage: null,// 背景图
      imgLoading: false,// 图片加载状态
      setSubjectiveScoreVisible: false,// 主观题分数设置是否可见
      currSubjective: {
        studentScore: 0
      },// 当前修改主观题
      updateStudentLoading: false,// 修改学生加载状态
      rules: {
        studentScore: [{ validator: checkStudentScore, trigger: "blur" }]
      },
      objectiveAnswerVisible: {},
      showChooseSubject: false, // 是否显示选科
      showReport: false, // 是否存在报告
      studentInfo: {
        examNo: '',
        studentName: '',
      },
      classId: "", // 当前查询班级ID
      classList: [],

      list: [],
      taskId: '', // 长任务id
      scheduleDialog: false, // 进度弹窗
      rendering: false,// 分数转红色
      dialogType: 'ocr',// 弹窗类型
      ocrDialog: {
        list: [],
        visible: false,
        templateNum: ''
      },
      isBatch: true,
      // POSITION_ERROR 定位异常， FOLDING_ANGLE_ISSUE 折角
      exceptions: ['POSITION_ERROR', 'FOLDING_ANGLE_ISSUE'],
      templateTip: `若您的答题卡是不同批次打印的，存在多个版式，扫描后有部分答题卡进入“定位异常”里，请创建多模板，并进行重识别。`,
      positionErrorList: [], // 定位异常批次列表
      batchId: 0,
      restoreScanBatchPaperVisible: false,
      allStand: {},
      isUpdateScore: false, // 是否修改分数
      schoolList: [],
      examId: '',
      isOldVersion: false,
      image: null,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    isPermission () {
      return (this.isRegion && this.userInfo.isAdmin) || !this.isRegion
    },
    amentiaReason () {
      return this.currStudent.examResult &&
        this.currStudent.examResult.amentiaFlag ? "是" : this.currStudent.amentiaReason || "否"
    },
    isAewIdentify () {
      return this.backDoor && this.examInfo.isHen === 1
    },
    isNeedBatch () {
      return ['DOUBT_REPEAT', 'DOUBT_STUDENT_ABSENT', 'NOT_IN_JOIN_LIST'].indexOf(this.studentType.id) > -1
    },
    stuSelectCount () {
      return this.studentSelection ? this.studentSelection.length : 0
    },
    backDoor () {
      return this.$store.state.backDoor
    },
    isOnline () {
      return this.examInfo.importType === 2
    },
    notStudentInfo () {
      return !(this.currStudent.studentId || this.currStudent.resultId)
    },
    isCreateTemplatePermission () {
      return !this.isOnline && this.isPlatFormPermission
    },
    isHenPermission () {
      return (this.examInfo.isHen !== 1 || !(this.examInfo.isHen === 1 && this.isOldVersion)) && this.isPlatFormPermission
    },
    isShowPositionError () {
      // 单校平台非区域考试||区域平台
      return (this.loginPlatform === "school" && !this.isRegion) || this.loginPlatform === 'region'
    },
    isPlatFormPermission () {
      return ((this.loginPlatform === "school" && !this.isRegion) || this.loginPlatform === 'region')
    },
    progressDesc () {
      return this.dialogType === 'ocr' ? '正在重识别，请稍候...' : '正在重建中，请稍候...'
    }
  },
  async created () {
    const canLook = auth.checkAuthPerm(['Answer-Sheet-Scan', 'Region-Exam-Single'], this.examInfo.permsDict)
    if (!canLook) {
      this.$message.warning('您没有查看学生答题卡的权限')
      return
    }
    this.answerSchoolId = this.schoolId
    this.examId = this.examInfo.id
    let type = this.$route.params.type
    let studentType = this.studentTypeList[0]
    if (!util.isEmpty(type)) {
      const curStudentType = this.studentTypeList.find(s => s.type === type)
      if (curStudentType) {
        studentType = curStudentType
      }
    }
    this.studentType = studentType
    this.getSheetTemplate()
    this.initData()
    // 2s后自动跳转到对应单选框上
    this.jumpRadio()
  },
  mounted () {
    // 尝试恢复轮询识别进度（如多模板创建完成后）
    const taskId = YJ_SCHOOL_STORAGE.getItem('ocrTaskId')
    if (taskId) {
      this.dialogType = 'ocr'
      this.taskId = taskId
      this.scheduleDialog = true
      YJ_SCHOOL_STORAGE.removeItem('ocrTaskId')
    }
  },
  methods: {
    clickItem: function (info) {
      this[info.method](info.item)
    },
    // 初始化数据
    async initData () {
      const resp = await getShowChooseSubject(this.examId)
      if (resp.success) {
        this.showChooseSubject = resp.body
      } else {
        this.$message.warning(resp.message)
      }
      const allStand = await getListAllStand({ examId: this.examId })
      if (allStand.success) {
        this.allStand = allStand.body
      }
      this.currScale = this.scaleCollection[1]
      // 判断是否已经存在报告
      this.showReport = this.examInfo.reportState && this.examInfo.examSign
      this.initSchool()
      this.initSchoolClasses()
    },
    // 从扫描批次跳转定位到对应的tab
    jumpRadio () {
      const target = this.studentTypeList.find(item => item.id === this.$route.query.tabName)
      if (target) {
        setTimeout(() => {
          this.studentType = target
          this.changeType(target)
        }, 2 * 1000);
      }
    },
    handleCurrentChange (val) {
      this.pagination.current = util.isEmpty(val) ? 1 : val
      this.getStudentPaper()
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.handleCurrentChange()
    },
    handleSelectionChange (val) {
      this.studentSelection = val;
    },
    handleRowChange (row, event, column) {
      this.currStudent = row
    },
    // 获取学生试卷相关
    async getStudentPaper () {
      this.studentListLoading = true
      let params = {
        classId: this.classId,
        examId: this.examInfo.id,
        keyWord: this.keyword,
        currentPage: this.pagination.current,
        pageSize: this.pagination.size,
        schoolId: this.answerSchoolId,
        type: this.studentType.id == "REFERRENCE_NUMBER" ? 'ALL' : this.studentType.id,
      }

      try {
        if (params.type === 'POSITION_ERROR') {
          if (this.positionErrorList.length === 0) {
            this.batchId = 0
            const batchParams = {
              examId: this.examInfo.id,
              schoolId: this.answerSchoolId
            }
            const batchResp = await examApi.getBatchList(batchParams)
            if (batchResp.success && batchResp.body) {
              const list = (batchResp.body || []).map(item => ({
                name: `第${item.name}批次`,
                value: item.value
              }))
              if (list.length > 0) {
                list.unshift({
                  name: '全部',
                  value: 0
                })
              }
              this.positionErrorList = list
              this.batchId = this.positionErrorList[0].value
            }
          }
          params.scanBatchId = this.batchId || null
        }
        // 增加选科判断
        if (this.showChooseSubject && !util.isEmpty(this.currOptional)) {
          params.chooseSubject = this.currOptional === 0
        }
        const isException = this.exceptions.indexOf(params.type) >= 0
        const resp = isException ? await examApi.getPositionException(params) : await getStudentPaper(params)
        if (resp.success && resp.body) {
          if (resp.body.paperCounts) {
            this.$emit('refreshDoubt')
            this.refreshCount(resp.body.paperCounts, resp.body.studentCount)
            if (params.type === 'ALL') {
              // ALL时，补充获取定位异常的错误总数
              await this.setPositionExceptionCount()
            }
          } else if (isException) {
            this.studentType.total = resp.body.totalSize
            this.studentType.customClass = this.studentType.total > 0 ? 'num' : ''
          }
          const studentAndPaper = resp.body.studentAndPaper || resp.body
          if (studentAndPaper) {
            let studentList = studentAndPaper.items
            studentList.forEach(item => {
              if (isException) {
                item.studentPaperType = params.type
                if (!item.examResult) {
                  item.examResult = {
                    isAnswer: true,
                    ossUrl: item.examScanPaper.ossUrl
                  }
                }
              }
              item.isAnswer = item.examResult && !util.isEmpty(item.examResult.ossUrl);
              item.NotAnnotations = item.isAnswer ? [item.examResult.ossUrl] : [];
              if (util.isEmpty(item.examNo) && item.studentVo) {
                item.examNo = item.studentVo.examNo
              }
            })
            this.studentList = studentList
            if (studentList.length > 0) {
              this.$nextTick(function () {
                let student = studentList[0]
                if (this.$route.query.resultId) {
                  let curStudent = studentList.find(s => s.resultId == this.$route.query.resultId)
                  if (curStudent) {
                    student = curStudent
                  }
                }

                if (this.$refs.studentList) {
                  this.$refs.studentList.setCurrentRow(student)
                }
                this.currStudent = student
              })
            } else {
              this.currStudent = { isAnswer: false, NotAnnotations: [], studentPaperType: params.type }
            }

            this.pagination.current = studentAndPaper.currentPage
            this.pagination.total = studentAndPaper.totalSize
          }
        }

        this.studentListLoading = false
      } catch (error) {
        this.studentListLoading = false
      }

      // 学生信息：重复、不存在、不在参考名单 存在批量
      if (this.isNeedBatch) {
        this.$nextTick(() => {
          if (this.$refs.batchQuestion) {
            this.$refs.batchQuestion.getStudentList()
          }
        })
      }
    },
    async setPositionExceptionCount () {
      const params = {
        examId: this.examInfo.id,
        currentPage: this.pagination.current,
        pageSize: this.pagination.size,
        schoolId: this.answerSchoolId
      }
      for (let index = 0; index < this.exceptions.length; index++) {
        const element = this.exceptions[index];
        const target = this.studentTypeList.find(item => item.id === element)
        if (!target) continue
        params.type = target.id
        const resp = await examApi.getPositionException(params)
        if (resp.body) {
          target.total = resp.body.totalSize
          target.customClass = target.total > 0 ? 'num' : ''
        }
      }
    },
    refreshCount (paperCounts, studentCount) {
      const typeList = this.studentTypeList.filter(item => this.exceptions.indexOf(item.id) === -1)
      for (let item of typeList) {
        if (item.id === 'REFERRENCE_NUMBER') {
          item.total = `${studentCount}`
        } else {
          const studentType = paperCounts.find(s => s.code == item.type)
          item.total = studentType ? studentType.count : 0
        }
        item.customClass = (item.type == 1 && item.total !== studentCount) || (item.type > 1 && item.total > 0) ? 'num' : ''
        // 追加自定义类型按钮
        if (item.id === 'UN_UPLOAD') {
          item.customButton = {
            type: 'download'
          }
        }
      }

      // 计算集合
      const list = [];
      list.push({
        desc: '',
        children: this.studentTypeList.slice(0, 6)
      })
      list.push({
        desc: '学生信息：',
        children: this.studentTypeList.slice(6)
      })
      this.list = list;
    },
    // 标记无名卷
    async labelUnnamedVolume () {
      const params = {
        examId: this.examInfo.id,
        detailIds: [this.currStudent.id]
      }
      const resp = await labelUnnamedVolume(params)
      if (resp.success) {
        this.labelUnnamedVolumeVisible = false
        this.handleCurrentChange()
        this.$message.success('标记成功!')
      } else {
        this.$message.warning(resp.message)
      }
    },
    // 删除试卷
    async delAnswerSheet () {
      if (this.stuSelectCount <= 0) return
      let resp = {}
      if (this.exceptions.indexOf(this.studentType.id) >= 0) {
        const scanIds = this.getScanIds()
        resp = await examApi.delScanBatchPaper(scanIds)
        this.setPositionExceptionCount()
      } else {
        const params = {
          examId: this.examInfo.id,
          url: this.delType === '2' ? `&reserveOld=${this.delStudentNumberType === '1'}` : '',
          resultIds: this.studentSelection.filter(item => !util.isEmpty(item.resultId)).map(item => item.resultId)
        }
        resp = await delStudentPaper(params)
      }
      if (resp.success) {
        this.delAnswerSheetVisible = false
        this.handleCurrentChange()
        this.$message.success('删除成功!')
      } else {
        this.$message.warning(resp.message)
      }
    },
    // 获取单个学生试卷信息
    async getDistinguish () {
      let subjectiveList = []; // 主观题
      let objectiveList = []; // 客观题
      this.imgLoading = true
      let params = {
        resultId: this.currStudent.resultId
          ? this.currStudent.resultId
          : this.currStudent.id,
        examId: this.examInfo.id
      };
      this.previewLoading = true;
      let resp = await getDistinguish(params);
      this.previewLoading = false;
      let data = resp.body.details;

      if (Array.isArray(data)) {
        for (let item of data) {
          if ([0, 1].indexOf(item.choiceType) > -1) {
            item.selectOptions = item.answer
            objectiveList.push({ ...item, showOptions: false });
          }
          if (item.choiceType == 2) {
            subjectiveList.push(item);
          }
        }
      }
      this.objectiveList = objectiveList;
      objectiveList.forEach((item, index) => {
        this.objectiveAnswerVisible[index] = false
      })
      this.subjectiveList = subjectiveList;
      this.dialogTableVisible = true;
      if (resp.body.examResult) {
        this.currStudent.examResult = resp.body.examResult
      } else {
        this.currStudent.examResult = {}
      }

      if (resp.body.amentiaReason) {
        this.currStudent.amentiaReason = resp.body.amentiaReason
      }
      this.initPreviewImg()
    },
    // 切换是否参与统计
    handleCountSwitch () {
      const student = this.currStudent;
      let msg = student.examResult.amentiaFlag ? "是否标记该考生本场考试参与统计？" : "是否标记该考生本场考试不参与统计？";
      this.$confirm(msg, "提示", {
        type: "warning",
        customClass: "close_confirm",
      }).then(async () => {
        let params = {
          examId: this.examId,
          studentId: student.studentId,
          flag: student.examResult.amentiaFlag ? 1 : 0
        };

        window.SlsSend({
          action: 'handleCountSwitch',
          desc: '切换是否参与统计',
          data: {
            result: params
          }
        })

        const resp = await setDistinguishMark(params)
        if (resp.success) {
          this.$message.success("标记成功")
        } else {
          this.$message.warning(`标记失败${resp.message}`)
        }
      }).catch(err => {
        student.examResult.amentiaFlag = student.examResult.amentiaFlag ? 0 : 1;
      });
    },
    // 切换是否缺考
    async handleChangeMissExam () {
      const flag = this.examState === '1' ? 1 : 0
      let params = {
        examId: this.examId,
        studentId: this.currStudent.studentId,
        flag: flag
      };
      window.SlsSend({
        action: 'handleChangeMissExam',
        desc: '切换是否缺考',
        data: {
          result: params
        }
      })
      const resp = await setDistinguishExamType(params)
      if (resp.success) {
        this.missExamVisible = false
        this.$message.success("标记成功")
        this.missExam = flag + '' === '1'
        this.handleCurrentChange()
      } else {
        this.$message.warning(`标记失败${resp.message}`)
      }
    },
    // 确认学生
    handleSearchStudentClick (student) {
      this.updateStudentLoading = true
      this.currStudent.studentVo = student
      this.currStudent.studentId = student.id
      this.currStudent.examNo = student.examNo
      this.currStudent.studentName = student.studName
      this.currStudent.examResult.flag == "0"
      this.currStudent.studentPaperType = 'UPLOAD'

      let params = {
        examId: this.examId,
        resultId: this.currStudent.resultId,
        studentId: student.id,
        schoolId: this.answerSchoolId,
        answerOrScore: {},
      };

      window.SlsSend({
        action: 'handleSearchStudentClick',
        desc: '确认学生',
        data: {
          result: params
        }
      })
      this.updateDistinguish(params, () => {
        this.$message.success('修改成功！')
        this.handleCurrentChange()
      })
    },
    // 修改学生信息及答案信息
    async updateDistinguish (params, callback) {
      const resp = await updateDistinguish(params)
      this.updateStudentLoading = false
      if (resp.success) {
        if (resp.body) {
          this.currStudent.resultId = resp.body.id || ''
        }

        if (callback) {
          callback()
        }
      } else {
        this.$message.warning(resp.message)
      }
    },
    //修改主观题分数弹窗显示
    handleChangeSubjectiveScoreVisible (subjective) {
      if (!this.isReadWritePermission(3)) {
        return
      }
      this.currSubjective = subjective
      this.setSubjectiveScoreVisible = true
    },
    // 修改主观题分数
    handleChangeSubjectiveScore () {
      this.$refs.setSubjectiveScore.validate(valid => {
        if (valid) {
          const answerOrScore = {}
          answerOrScore[this.currSubjective.num] = this.currSubjective.studentScore
          let params = {
            examId: this.examId,
            resultId: this.currStudent.resultId,
            studentId: this.currStudent.studentId,
            schoolId: this.answerSchoolId,
            answerOrScore: answerOrScore
          };

          this.updateDistinguish(params, () => {
            this.isUpdateScore = true
            this.$message.success('修改成功！')
            this.currSubjective.score = this.currSubjective.studentScore
            this.refreshScore()
            this.changeGradingRecord(this.currSubjective.num)
          })

          this.setSubjectiveScoreVisible = false
        } else {
          return false;
        }
      });
    },
    // 刷新分值
    refreshScore () {
      let totalScore = 0
      let subScore = 0
      let objScore = 0
      if (this.subjectiveList) {
        const score = this.subjectiveList.reduce((sum, e) => sum + Number(e.score || 0), 0)
        totalScore += score
        subScore = score
      }
      if (this.objectiveList) {
        const score = this.objectiveList.reduce((sum, e) => sum + Number(e.score || 0), 0)
        totalScore += score
        objScore = score
      }

      // 总分
      if (this.currStudent.examResult) {
        this.currStudent.examResult.subScore = subScore
        this.currStudent.examResult.objScore = objScore
        this.currStudent.examResult.totScore = totalScore
      }
    },
    // 旋转
    handleRotate () {
      this.rotateIndex++
      if (this.rotateIndex / 4 === 0) {
        this.rotateIndex = 1
      }
      this.zoomCanvas()
    },
    // 初始化预览图片信息
    initPreviewImg () {
      // 无答案
      if (!this.currStudent.isAnswer) {
        this.currStudent.NotAnnotations = []
        this.previewImg.src = ''
        this.previewImg.list = []
        this.imgLoading = false
        return
      }

      if (this.currStudent.NotAnnotations && this.currStudent.NotAnnotations.length > 0) {
        this.previewImg.src = this.currStudent.NotAnnotations[0]
        this.previewImg.list = this.currStudent.NotAnnotations
      } else {
        this.imgLoading = false
      }
    },
    async showGradingRecord () {
      const vm = this
      // 客观题标记
      if (vm.objectiveList) {
        for (let objective of vm.objectiveList) {
          sDraw.markOptions(vm.canvas, objective, this.showCorrectionDetail)
        }
      }
      this.setAllStand(!this.showCorrectionDetail)
      await this.changeGradingRecord()
      this.imgLoading = false
      vm.zoomCanvas()
    },
    setAllStand (isShow) {
      // 设置主副模板坐标
      const quesList = []
      this.allStand.examStandVos.forEach(item => {
        const ques = item.templatePositionList.find(s => s.templateNum === this.currStudent.examResult.templateNum)
        if (ques) {
          ques.num = item.num
          ques.title = util.standardQuestionNumber(item)
          ques.choiceTypeCode = item.choiceTypeCode
          quesList.push(ques)
        }
      })
      // 绘制试题
      quesList.forEach(item => {
        item.positionList.forEach((pos, index) => {
          const ques = {
            num: item.num,
            ...pos,
            color: '#2877FF',
            value: item.num,
            part: index
          }
          sDraw.markBox(this.canvas, ques, isShow)
          // 添加题号
          ques.text = item.title
          if (item.choiceTypeCode === 1) {
            ques.fontSize = 14
            ques.hideStroke = true
          }
          sDraw.markBox(this.canvas, ques, isShow)
          item.optionList.forEach((option, index) => {
            const ques = {
              num: item.num + '-' + index,
              ...option,
              color: 'red',
              value: index,
              part: index
            }
            sDraw.markBox(this.canvas, ques, isShow)
          })
        })
      })
    },
    // 更新主观题批注
    async changeGradingRecord (key = "") {
      const vm = this
      const resultId = vm.currStudent.resultId;
      if (util.isEmpty(resultId)) {
        return
      }

      if (vm.showCorrectionDetail) {
        // 主观题标记
        const resp = await getGradingRecord({
          resultIds: resultId,
          schoolId: vm.answerSchoolId
        })

        if (resp.success) {
          if (resp.body && resp.body[resultId]) {
            let list = resp.body[resultId]
            if (!util.isEmpty(key)) {
              list = list.filter(item => item.num === key)
            }
            list.forEach(item => {
              item.part = 0
            })
            sDraw.markPaper(vm.canvas, list)
          }
        } else {
          vm.$message.warning(resp.message)
        }
      } else {
        const list = []
        vm.subjectiveList.forEach(item => {
          list.push({ num: item.num, part: 0 })
        })
        sDraw.markPaper(vm.canvas, list, false)
      }
    },
    // 缩放
    zoomCanvas () {
      const vm = this
      if (vm.timer) {
        clearTimeout(vm.timer)
      }
      // 防抖
      vm.timer = setTimeout(() => {
        const xCanvas = vm.canvas
        if (xCanvas && xCanvas.setZoom) {
          xCanvas.setZoom(vm.currScale.value);
          const zoom = xCanvas.getZoom()
          xCanvas.setWidth(vm.backgroundImage.width * zoom);
          xCanvas.setHeight(vm.backgroundImage.height * zoom);
          xCanvas.renderAll();
          vm.$nextTick(() => {
            const warpper = document.querySelector('.student-img-warpper')
            if (warpper) {
              warpper.scrollTop = 0
              warpper.scrollLeft = 0
            }
            vm.imgLoading = false
          })
        }
      }, 0.01 * 1000);

      this.initImgStyle()
    },
    // 修改缩放比
    handleChangeScale (scale) {
      this.currScale = scale
      this.scaleDownVisible = false
    },
    // 初始化图片样式
    initImgStyle () {
      if (!this.image) {
        return
      }
      const width = this.image.width * this.currScale.value
      const height = this.image.height * this.currScale.value
      const isAngle = this.rotateIndex % 2 === 0
      this.imageStyle = {
        width: width + 'px',
        height: height + 'px',
        'margin-left': `${!isAngle ? -((width - height) / 2) : 0}px`,
        'margin-top': `${!isAngle ? ((width - height) / 2) : 0}px`,
        transform: `rotate(-${90 * this.rotateIndex}deg)`
      }
    },
    initObjectiveAnswer (objective) {
      objective.selectOptions = objective.answer.split('')
    },
    // 修改客观题答案
    changeObjectiveAnswer (objective) {
      const answer = objective.selectOptions.sort().join('')
      // 答案一致不做处理
      if (answer === objective.answer) {
        return
      }
      this.updateStudentLoading = true
      const answerOrScore = {}
      answerOrScore[objective.num] = answer

      let params = {
        examId: this.examId,
        resultId: this.currStudent.resultId,
        studentId: this.currStudent.studentId,
        schoolId: this.answerSchoolId,
        answerOrScore: answerOrScore
      };
      objective.selectOptions = objective.answer
      this.updateDistinguish(params, () => {
        this.isUpdateScore = true
        let message = '答案修改成功'
        if (this.showReport) {
          message += '，请重新生成报告获取最新成绩'
        }
        this.$message.success(message)
        // 修改成功后需要修改答案
        objective.answer = answer
        objective.selectOptions = answer
        // 更新分值
        objective.score = this.getPoint(objective)
        this.refreshScore()
        // 修改前端绘制
        sDraw.markOptions(this.canvas, objective, this.showCorrectionDetail)
      })
    },
    changeOption (objective, option) {
      if (!this.isReadWritePermission(3)) {
        return
      }

      if (objective.selectOptions.indexOf(option) > -1) {
        objective.selectOptions.splice(objective.selectOptions.indexOf(option), 1)
      } else {
        // 检测单选题不得选多个选项
        if (objective.choiceType === 1) {
          objective.selectOptions = [option]
          // 手动关闭当前弹窗
          // 注意：需要加[0]是因为ref返回的是数组
          const objectiveRef = this.$refs[`objective-${objective.num}`]
          if (objectiveRef && objectiveRef.length > 0) {
            objectiveRef[0].doClose();
          }
        } else {
          objective.selectOptions.push(option)
        }
      }
    },
    getSelectOptionStyle (objective, option) {
      const isOptionSelect = objective.selectOptions.indexOf(option) > -1
      return {
        background: isOptionSelect ? 'black' : '',
        color: isOptionSelect ? 'white' : ''
      }
    },
    getObjectiveAnswerStyle (item) {
      return networkData.getObjectiveAnswerStyle(item)
    },
    // 获取客观题分值
    getPoint (item) {
      return networkData.getObjectivePoint(item)
    },
    handPreview () {
      this.previewImage = this.canvas.toDataURL();
      this.$nextTick(() => {
        this.$refs.preview.showViewer = true;
      })
    },
    changeType (type) {
      // 只有异常项（不存在、不在参考名单）才默认批量
      this.isBatch = ['CLASS_NO_EXIST', 'NOT_IN_JOIN_LIST'].includes(type.doubtType)
      this.studentType = type;
    },
    // 登分框重识别
    anewIdentify () {
      examApi.anewIdentify({
        examId: this.examId,
        examResultDetailTypes: ["SUBJECTIVE"],
        rendering: this.rendering
      }).then(res => {
        if (res.success && res.body) {
          this.dialogType = 'ocr'
          this.taskId = res.body
          this.scheduleDialog = true
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 关闭进度条
    closeProgress (state) {
      this.scheduleDialog = false
      this.taskId = ''
      if (state) {
        this.handleCurrentChange()
      }
    },
    // 导出未上传学生数据
    exportReport (item) {
      this.exportStudent(item.id)
    },
    // 导出学生名单
    exportStudent (type) {
      const params = {
        examId: this.examId,
        schoolId: this.answerSchoolId,
        type
      }
      if (this.showChooseSubject && !util.isEmpty(this.currOptional)) {
        params.chooseSubject = this.currOptional === 0
      }
      exportStudent(params).then(resp => {
        if (resp.body) {
          window.open(resp.body, "_blank");
        }
      })
    },
    reUpload () {
      this.$confirm("是否确认打回重传?", "提示", {
        type: "warning"
      }).then(async () => {
        const params = {
          examId: this.examId,
          schoolId: this.answerSchoolId,
          resultId: this.currStudent.resultId
        }
        examApi.returnOnlineExamResult(params).then(resp => {
          if (resp.success) {
            this.$message.success("设置成功");
          } else {
            this.$message.error(resp.message);
          }
        })
      }).catch(() => { });
    },
    // 导出异常名单
    downloadAnomalyList () {
      this.$router.push({
        path: '/tem/download', query: {
          examId: this.examId,
          title: this.examInfo.examName,
          type: 'abnormalTestPaper'
        }
      })
    },
    reNewStudent () {
      magicApi.reNewStudent(this.examId).then(resp => {
        if (resp.success && resp.body) {
          this.dialogType = 'student'
          this.taskId = resp.body
          this.$nextTick(() => {
            this.$refs.progressRef.startSchedule()
          })
        } else {
          this.$message.error(resp.message)
          this.scheduleDialog = false
        }
        this.scheduleDialog = true
      })
    },
    // 读写权限 type: 1:无权限  2：读权限 3：写权限
    // 非区域平台：权限限制
    isReadWritePermission (type = 2) {
      return (this.loginPlatform === 'school' && ((this.isRegion && this.examInfo.scorePermission >= type) || !this.isRegion)) || this.loginPlatform === 'region'
    },
    createMultiTemplate () {
      const scanIds = []
      let ossUrls = []
      let unUploads = []
      let resultId = 0
      let scanPaperId = 0
      for (let index = 0; index < this.stuSelectCount; index++) {
        const stu = this.studentSelection[index];
        if (stu.examScanPaper) {
          ossUrls.push(stu.examScanPaper.ossUrl)
          scanIds.push(stu.examScanPaper.id)
        }
        if (index === 0) {
          scanPaperId = stu.examScanPaper ? stu.examScanPaper.id : 0
          if (!scanPaperId) {
            resultId = stu.resultId
          }
        }
        if (stu.studentPaperType === 'UN_UPLOAD') {
          unUploads.push(stu)
        }
      }
      if (unUploads.length > 0) {
        return this.$message.warning('未上传答题卡的学生不能创建多模版')
      }
      if (scanIds.length === 0) {
        return this.$message.warning('请选择一个学生')
      }
      // 缓存scanIds，防止数据量过大
      YJ_SCHOOL_STORAGE.setItem('scanIds', JSON.stringify(scanIds));
      const query = {
        name: this.examInfo.gradeName + this.examInfo.subjectName + Date.now(),
        type: this.examInfo.isHen === 0 ? 'NON_WRITING' : 'WRITING',
        grade: this.examInfo.grade,
        subjectCode: this.examInfo.subjectCode,
        ossUrl: encodeURIComponent(ossUrls[0]),
        examId: this.examInfo.id,
        from: 'multi',
        page: this.$route.name
      }
      if (['POSITION_ERROR'].indexOf(this.studentType.id) >= 0) {
        query.exception = true
      }
      if (scanPaperId) {
        query.scanPaperId = scanPaperId
      } else {
        query.resultId = resultId
      }
      if (['POSITION_ERROR'].indexOf(this.studentType.id) >= 0 && this.batchId) {
        query.scanBatchId = this.batchId
      }
      this.$router.push({
        path: '/v2/card/third/cut',
        query: query
      })
    },
    restorePaperAction () {
      if (this.getScanIds().length === 0) {
        return this.$message.warning('请选择一个学生')
      }
      this.restoreScanBatchPaperVisible = true
    },
    reOcr () {
      examApi.gtMultiTemplates([this.examInfo.id]).then(resp => {
        const list = resp.body
        if (list) {
          if (list.length) {
            this.ocrDialog.templateNum = list[0].templateNum
          }
          this.ocrDialog.scanIds = this.getScanIds()
          this.ocrDialog.templates = list
          this.ocrDialog.visible = true
        }
      })
    },
    setPositionError () {
      // 标记为定位异常
      const scanIds = []
      for (let index = 0; index < this.stuSelectCount; index++) {
        const stu = this.studentSelection[index]
        scanIds.push(stu.id)
      }
      if (scanIds.length === 0) {
        return this.$message.warning('请选择一个学生')
      }
      examApi.setPaperPositionError(this.examId, scanIds).then(resp => {
        if (resp.success) {
          this.$message.success('标记为定位异常成功')
          this.handleCurrentChange(1)
          this.setPositionExceptionCount()
        } else {
          this.$message.warning(resp.message)
        }
      })
    },
    ocrTemplate () {
      const params = {
        examId: this.examId,
        fullPaperRecognition: true,
        templateNum: this.ocrDialog.templateNum,
        scanIds: this.ocrDialog.scanIds
      }
      examApi.anewIdentify(params).then(res => {
        if (res.success && res.body) {
          this.dialogType = 'ocr'
          this.taskId = res.body
          this.$nextTick(() => {
            this.$refs.progressRef.startSchedule()
          })
        } else {
          this.$message.warning(res.message)
          this.scheduleDialog = false
        }
      }).finally(() => {
        this.scheduleDialog = true
        this.ocrDialog.visible = false
      })
    },
    restoreScanBatchPaper () {
      const scanIds = this.getScanIds()
      examApi.restoreScanBatchPaper(scanIds).then(resp => {
        if (resp.success) {
          this.handleCurrentChange(1)
          this.setPositionExceptionCount()
          this.$message.success("还原成功")
        } else {
          this.$message.warning(resp.message)
        }
        this.restoreScanBatchPaperVisible = false
      })
    },
    confirmDoubt () {
      const scanIds = this.getScanIds()
      examApi.confirmDoubt({ scanPaperIds: scanIds, type: this.studentType.id }).then(resp => {
        if (resp.success) {
          this.handleCurrentChange(1)
          this.setPositionExceptionCount()
          this.$message.success('确认完毕')
        }
      })
    },
    getScanIds () {
      const scanIds = []
      for (let index = 0; index < this.stuSelectCount; index++) {
        const stu = this.studentSelection[index];
        if (stu.examScanPaper) {
          scanIds.push(stu.examScanPaper.id)
        }
      }
      return scanIds
    },
    // 取消全部学生缺考标记
    cancelAllAbsenceMarks () {
      this.$confirm("确认取消全部学生的缺考标记?", "确认提示", { type: "warning" }).then(async () => {
        examApi.cancelAllAbsenceMarks({ examId: this.examId }).then(resp => {
          if (resp.success) {
            this.$message.success("取消全部缺考标记成功");
          } else {
            this.$message.error(resp.message);
          }
        })
      }).catch(() => { });
    },
    handleChangeSchool () {
      this.$emit('changeSchool', this.answerSchoolId)
      if (this.isNeedBatch) {
        this.$nextTick(() => {
          if (this.$refs.batchQuestion) {
            this.$refs.batchQuestion.getStudentList()
          }
        })
      }
      this.initSchoolClasses();
      this.handleCurrentChange();
    },
    initSchool () {
      // 学校处理进度
      let schoolList = [{
        id: this.userInfo.schoolId,
        schoolName: this.userInfo.schoolName
      }];
      for (let item of this.examInfo.examSchools) {
        if (item.schoolId == "0") continue;
        if (item.school) {
          let obj = {
            id: item.school.id,
            schoolName: item.school.schoolName,
          };
          schoolList.push(obj);
        }
      }
      this.schoolList = schoolList;
      if (this.answerSchoolId === "" || !schoolList.some(school => school.id === this.answerSchoolId)) {
        this.clickItem('changeSchool', schoolList[0].id || '')
      }
    },
    initSchoolClasses () {
      // 无班级，需处理
      let classList = [];
      this.classId = ''
      const classes = this.examInfo.classes || []
      classes.filter(s => s.schoolId === this.answerSchoolId).forEach(item => {
        classList.push({
          id: item.id,
          className: item.className
        });
      })
      this.classList = classList;
    },
    UnnamedVolumeClick () {
      if (['NO_NAME_PAPER'].indexOf(this.currStudent.studentPaperType) > -1) {
        this.$message.warning('未识别学生信息，请重新绑定学生！')
      } else {
        this.labelUnnamedVolumeVisible = true
      }
    },
    getSheetTemplate () {
      examApi.getSheetTemplate(this.examId).then(res => {
        if (res.success) {
          this.isOldVersion = util.isEmpty(res.body) || (res.body && res.body.version === 'V1')
        }
      })
    }
  },
  watch: {
    studentType: function (val) {
      this.getStudentPaper()
    },
    delAnswerSheetVisible: function (val) {
      if (val) {
        this.delType = "1";
        this.delStudentNumberType = "1";
      }
    },
    currStudent: function (val) {
      this.missExam = val && val.examResult && val.examResult.flag === 1 ? true : false;
      this.isNameless = val && val.studentPaperType == "NO_NAME_PAPER"
      this.rotateIndex = 0
      this.studentInfo = {
        examNo: val.examNo,
        studentName: val.studentName
      }
      this.objectiveList.forEach(s => { s.answer = '', s.score = 0 })
      this.subjectiveList.forEach(s => s.score = 0)
      if (!val.NotAnnotations || val.NotAnnotations.length === 0 || this.missExam) {
        this.showCorrectionDetail = false
      }

      // 2025/03/07 @刘习  判断是否有学生答题卡及学生id
      if (this.notStudentInfo) {
        this.refreshScore()
        this.initPreviewImg()
      } else {
        this.getDistinguish()
      }
    },
    objectiveAnswerVisible: {
      handler (newVal, oldVal) {
      },
      deep: true
    },
    missExamVisible: function (val) {
      this.examState = this.currStudent && this.currStudent.studentPaperType === 'UN_UPLOAD' ? '1' : this.missExam ? '1' : '2'
    },
    currScale: function (val, oldVal) {
      if (this.previewImg.src) {
        this.zoomCanvas()
      }
    },
    'previewImg.src': function (val) {
      if (!util.isEmpty(val)) {
        const vm = this
        if (vm.canvas) {
          vm.canvas.clear()
        } else {
          const dom = vm.$refs.studentImg
          vm.canvas = new fabric.Canvas(dom, {
            includeDefaultValues: false,
            selection: false
          })
        }

        fabric.Image.fromURL(xDraw.getNewUrl(val), function (image) {
          vm.image = image
          vm.canvas.setWidth(0)
          vm.canvas.setHeight(0)
          vm.canvas.setBackgroundImage(image, vm.canvas.renderAll.bind(vm.canvas))
          vm.backgroundImage = image
          vm.showGradingRecord()
        })
      } else {
        this.image = null
        this.imgLoading = false
      }
    },
    showCorrectionDetail: function (val) {
      this.imgLoading = true
      this.showGradingRecord()
    },
    schoolId: function (val) {
      this.answerSchoolId = val
    }
  },
  filters: {
    standardQuestionNumber (val) {
      if (util.isEmpty(val)) {
        return '--'
      }
      return util.standardQuestionNumber(val);
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isUpdateScore && !this.isRegion && this.showReport) {
      this.$root.$children[0].checkAndGenerateReport(this.examId, next)
    } else {
      next()
    }
  }
}
</script>
<style scoped lang="scss">
.student-answer {
  background: #fff;
  min-height: 600px;
}

.student-answer .ques-type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e5e5e5;
  color: #333;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.student-answer .ques-type .type {
  display: flex;
  align-items: center;
}

.student-answer .ques-type .type .type-tip {
  color: #3a3a3a;
}

.student-answer .ques-type .options {
  width: 100px;
  margin-right: 8px;
}

.student-answer .ques-type .options .option,
.student-answer .ques-type .options ::v-deep input {
  color: #999;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.student-answer .search-wrapper {
  margin: 7px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.student-answer .search-wrapper .switch-sort {
  cursor: pointer;
  z-index: 99;
  color: #606266;
  font-size: 14px;
}

.student-answer .student-answer-content {
  display: flex;
  height: 768px;
  align-items: normal;
}

.student-answer .student-answer-content .student-list {
  border: 1px solid #e5e5e5;
  background: #fff;
  width: 232px;
  margin-right: 8px;
}

.student-answer .student-answer-content .student-img {
  border: 1px solid #e5e5e5;
  background: #fff;
  width: 742px;
  margin-right: 8px;
  position: relative;
}

.student-answer .student-answer-content .student-img .tab-bar {
  border-bottom: 1px solid #e5e5e5;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.student-answer .student-answer-content .student-img .tab-left {
  margin-left: 16px;
  color: rgba(51, 51, 51, 0.9);
  text-align: center;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.student-answer .student-answer-content .student-img .tab-right {
  display: flex;
  align-items: center;
}

.student-answer .student-answer-content .student-img .tab-right > i {
  cursor: pointer;
}

.student-answer .student-answer-content .student-img .student-img-warpper {
  width: 742px;
  height: 728px;
  overflow: auto;
  position: relative;
}

.student-answer .student-answer-content .student-img .marking-desc {
  position: absolute;
  top: 45px;
  right: 5px;
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
  max-width: 100%;
  padding: 5px;
}

.student-answer
  .student-answer-content
  .student-img
  .student-img-warpper
  .nodata {
  margin-top: 228px;
}

.student-answer
  .student-answer-content
  .student-img
  .student-img-warpper
  .nodata-text {
  margin-top: 20px;
  color: rgba(102, 102, 102, 1);
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 14px;
}

.student-answer .footer {
  display: flex;
  justify-content: space-between;
  margin: 0 16px;
  align-items: center;
  height: 70px;
}

.student-answer .footer .btn {
  color: rgba(51, 51, 51, 0.9);
  text-align: center;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  cursor: pointer;
  margin-right: 27px;
}

.student-answer .footer .desc {
  color: rgba(51, 51, 51, 0.9);
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.student-answer .identify-tip {
  display: block;
  margin-left: 165px;
  text-align: left;
}

.student-answer .label-unnamed-volume .content {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 34px;
  color: #333;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.student-answer .miss-exam .dialog-footer,
.student-answer .del-answer-sheet .dialog-footer,
.student-answer .label-unnamed-volume .dialog-footer,
.set-subjective-score .dialog-footer {
  margin: 40px 0 20px 0;
  justify-content: center;
}

.student-answer .del-answer-sheet .content {
  display: flex;
  justify-content: space-evenly;
  min-height: 80px;
}

.student-answer .del-answer-sheet .content .left {
  width: 35%;
}

.student-answer .del-answer-sheet .content .right {
  width: 40%;
}

.student-answer .del-answer-sheet .content .title {
  color: #333;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.student-answer .del-answer-sheet .content .left .text {
  margin-top: 17px;
  color: #666;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}

.student-answer .student-answer-content .student-info {
  width: 210px;
  border: 1px solid #e5e5e5;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.student-answer .student-answer-content .student-info .nodata {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 14px;
  color: #909399;
  line-height: 60px;
}

.student-answer .student-answer-content .student-info .student-detail {
  text-align: left;
  padding: 16px;
  border-bottom: 1px solid #f5f6f7;
}

.student-answer .student-answer-content .student-info .student-detail > div {
  display: flex;
  align-items: center;
  max-height: 32px;
  margin-bottom: 5px;
}

.student-answer .student-answer-content .student-info .student-detail .label {
  color: rgba(153, 153, 153, 0.9);
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.student-answer .student-answer-content .student-info .student-detail .text {
  color: var(--text-icon-font-gy-190-primary, rgba(0, 0, 0, 0.9));
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  max-width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.student-answer .student-answer-content .student-info .question-list {
  align-items: left;
  overflow: auto;
}

.student-answer .student-answer-content .student-info .question-list .title {
  margin: 21px 16px 13px 16px;
  height: "22px";
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(51, 51, 51, 0.9);
  font-family: "PingFang SC";
  font-weight: 500;
  font-size: "14px";
  line-height: "22px";
}

.student-answer .student-answer-content .student-info .question-list > ul {
  display: flex;
  flex-wrap: wrap;
}

.student-answer
  .student-answer-content
  .student-info
  .question-list
  .subjective-question
  .question-num,
.student-answer
  .student-answer-content
  .student-info
  .question-list
  .objective-question
  .question-num {
  width: 44px;
  height: 32px;
  border-radius: 4px;
  background: rgba(243, 243, 243, 1);
  color: rgba(51, 51, 51, 1);
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  margin-left: 6px;
  margin-bottom: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.student-answer
  .student-answer-content
  .student-info
  .question-list
  .objective-question
  .question-answer {
  width: 44px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  padding: 0px;
  cursor: pointer;
  margin-left: 6px;
  margin-bottom: 8px;
  background: rgba(26, 176, 113, 1);
  color: rgba(255, 255, 255, 1);
  font-family: PingFang SC;
  font-size: 12px;
}

.student-answer
  .student-answer-content
  .student-info
  .question-list
  .subjective-question
  .question-score {
  width: 44px;
  height: 32px;
  border-radius: 4px;
  padding: 0px;
  margin-left: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  color: rgba(51, 51, 51, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
}

.student-answer .miss-exam .content {
  text-align: center;
  color: #333;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.student-answer .set-subjective-score .el-dialog__body .el-form-item {
  margin-bottom: 0;
}

.student-answer
  .set-subjective-score
  .el-dialog__body
  .el-form-item
  .el-form-item__label {
  height: 22px;
  color: rgba(153, 153, 153, 0.9);
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 22px;
}

.help-icon {
  display: inline-block;
  width: 16px;
  height: 20px;
  background-size: 100%;
  background-image: url(../../assets/images/help-circle.png);
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  vertical-align: sub;
}
</style>

<style lang="scss">
.student-answer .ques-type .num {
  color: #ff4c3b;
}

.student-answer ._search-wrapper > ._search > .button {
  border-radius: 0 4px 4px 0;
  height: 26px;
  width: 30px;
}

.student-answer ._search-wrapper > ._search > .button > img {
  width: 10px;
  height: 10px;
}

.student-answer ._search-wrapper ._search .el-input {
  border-radius: 4px 0 0 4px;
  height: 26px;
}

.student-answer
  .student-answer-content
  .student-list
  .el-table__header-wrapper
  .el-table__header
  .el-table-column--selection
  .cell,
.student-answer
  .student-answer-content
  .student-list
  .el-table__body-wrapper
  .el-table__body
  .el-table__row
  .cell {
  padding: 0;
}

.student-answer .ques-type .el-input__suffix {
  height: 28px;
}

.student-answer .del-answer-sheet .content .right .text {
  margin-top: 12px;
  margin-left: 24px;
  color: #333;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}

.student-answer
  .student-answer-content
  .student-info
  .student-detail
  .no-border
  .el-input__inner {
  padding: 0 8px;
  height: 26px;
}

.student-answer
  .student-answer-content
  .student-info
  .student-detail
  .no-border
  .el-input__inner:focus {
  border: 1px solid #2877ff;
}

/*  交换 确定 和 取消 按钮的位置 */
.close_confirm .el-message-box__btns {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;

  .el-button {
    margin: 0 0.5rem;
  }
}

.student-answer
  .student-answer-content
  .student-info
  .student-detail
  .exam-result {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.student-answer
  .student-answer-content
  .student-info
  .student-detail
  .exam-result
  .el-switch
  .el-switch__core {
  width: 26px !important;
  height: 16px;
}

.student-answer
  .student-answer-content
  .student-info
  .student-detail
  .exam-result
  .el-switch
  .el-switch__core::after {
  width: 15px;
  height: 14px;
  margin-top: -1px;
  margin-bottom: 2px;
}

.scale-item-popover .scale-item-more .scale-item {
  overflow: hidden;
  color: rgba(51, 51, 51, 0.9);
  text-overflow: ellipsis;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}

.scale-item-popover .scale-item-more .scale-item.active {
  color: #2877ff;
}

.preview-img .el-image__inner,
.preview-img .el-image__error,
.preview-img > img {
  display: none;
}

.search-student-list {
  max-height: 120px;
  min-height: 30px;
  overflow: auto;
  display: flex;
}

.search-student-list > li {
  height: 22px;
  width: 27px;
  color: rgba(51, 51, 51, 1);
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  margin-top: 5px;
  text-align: center;
}

.objective-popover {
  padding: 0;
}

.el-autocomplete-suggestion[x-placement^="bottom"] {
  text-align: center;
  width: 200px !important;
}

.span-btn {
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
  color: #333;
}

.span-btn:hover {
  color: #2877ff;
}

.span-btn.disabled {
  color: #999;
  cursor: not-allowed;
}

.dialog-body-content {
  text-align: left;
}

.help-tip-popover {
  max-width: 200px;
  line-height: 1.5;
}
</style>
